import React, { useContext } from "react";
import { Box } from "@mui/material";
import { Line } from "react-chartjs-2";
import 'chartjs-adapter-date-fns';
import { format } from "date-fns";
import { darkerGrey, green } from "../../shared/colours";
import { ThemeModeContext } from "../../shared/Theme";
import Chart from 'chart.js/auto';

const BreachLineGraph = (props) => {
	
	const themeModeContext = useContext(ThemeModeContext);
	
	const options = {
		plugins: {
			legend: {
				display: false
			}
		},
		scales: {
			x: {
				ticks: {
					color: themeModeContext.themeMode === "light"? darkerGrey : green,
					font: {
						size: 10
					}
				}
			},
			y: {
				ticks: {
					beginAtZero: true,
					color: themeModeContext.themeMode === "light"? darkerGrey : green,
					font: {
						size: 10
					}
				}
			}
		},
		maintainAspectRatio: false
	};
	
	const getData = () => {
		if (props.fromDate === null || props.toDate === null) return;
				
		const graphBreaches = props.breaches.sort((a, b) => {
			if (a.breach_date < b.breach_date) return -1;
			else if (a.breach_date > b.breach_date) return 1;
			else return 0;
		});
		
		const breachCounts = {};
		for (let i = 0; i < graphBreaches.length; i++) {
			// const key = `${format(graphBreaches[i].breach_date, "MM-yyyy")} - ${graphBreaches[i].name}`;
			const key = `${format(graphBreaches[i].breach_date, "yyyy")}`;
			if (!breachCounts.hasOwnProperty(key)) {
				breachCounts[key] ={
					name: key,
					count: 0
				};
			}
			breachCounts[key].count += 1;
		}
		
		const breachData = [];
		const breachCountKeys = Object.keys(breachCounts);
		for (let i = 0; i < breachCountKeys.length; i++) {
			const key = breachCountKeys[i];
			breachData.push(breachCounts[key].count);
		}
		
		const data = {
			labels: breachCountKeys,
			datasets: [{
				label: "Exposed Credentials",
				data: breachData,
				backgroundColor: "rgba(0, 0, 0, 0)",
				borderColor: "#ff03ed",
				fill: true,
				lineTension: 0.3,
			}]
		};
		
		return data;
	};
	
	return (
		<Box sx={{ width: "100%", paddingBottom: "1em" }}>
			<Box sx={{
				flexGrow: 1,
				border: "2px",
				width: "90%",
				height: "9em",
				margin: "1em auto"
			}}>
				<Line data={getData()} options={options} height="10em"/>
				{/* <Line data={getData} options={options} width="100%"/> */}
			</Box>
		</Box>
	);
	
};

export default BreachLineGraph;